<template>
<div>
    <v-card>
        <v-card-title>
            Search device
            <v-spacer></v-spacer>            
            <v-btn color="primary" to="/AdminUsers">Search user</v-btn>
            <div class="ma-2"></div>
            <v-btn to="/deviceList">back to devices page</v-btn>
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col cols="12" sm="4" md="4">
                    <v-text-field col="md-4"
                        v-model="macaddress"
                        prepend-icon="mdi-magnify"
                        label="MAC Address"
                        single-line
                        hide-details
                    ></v-text-field>
                </v-col>

                <v-col cols="12" sm="2" md="2">
                    <v-btn 
                    color="primary"
                    @click="searchDevice"
                    :disabled="!macaddress"
                    >Search</v-btn>                        
                </v-col>
            </v-row>
            <v-row>                
                <v-col cols="12" sm="4" md="4">
                    
                <v-card v-if="device.id">
                    <v-card-title>
                        MAC Address : {{device.macaddress}}
                    </v-card-title>
                    <v-card-text>
                        <div class="text-body-2">
                            <span class="text-body-1 font-weight-bold">Owner : {{device.owner}}</span><br>
                            <span class="text-body-1">Name :</span> {{device.name}}<br>
                            <span class="text-body-1">PSK :</span> {{device.psk}}<br>
                            <span class="text-body-1">Remark :</span> {{device.remark}}<br>
                        </div>
                    </v-card-text>

                    <v-card-actions>
                        <v-btn
                        text
                        color="red"                        
                        @click="deleteDevice"
                        >delete</v-btn>

                    </v-card-actions>
                </v-card>
                </v-col>
            </v-row> 
            <v-row>
                <v-col cols="12" sm="6" md="6">
                    <v-alert outlined :type="errorMsg.type" v-if="errorMsg.show">
                        {{errorMsg.text.statusText}}<br>        
                        {{errorMsg.text}}        
                    </v-alert>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
    
</div>
</template>

<script>
import Vue from 'vue';
import axios from "axios";

export default Vue.extend({
    name: "AdminDevices",
    data: () => ({
        macaddress: null,
        device: {},
        access_token: sessionStorage.getItem('access_token'),
        errorMsg: {show:false, text:null, type:"error"},
        search: '',
        headers: [
            {text: 'id', value: 'id', filterable: false},
            {text: 'time', value: 'time'},
            {text: 'message', value: 'str_message'}
        ]
    }),    

    methods: {
        searchDevice () {
            this.errorMsg.show=false            
            axios
            .get(
                this.$store.state.api_url+`/devices/`+this.macaddress,
                {headers: { Authorization: `Bearer ${this.access_token}`}}
            )
            .then((response)=>{
                this.device = response.data[0]                
            })
            .catch((error)=>{
                if (error.response) {        
                    //this.$router.push(`/Error?errorCode=${error.response.status}&errorText=${error.response.statusText}`)
                    const errTxt = {
                        status: error.response.status,
                        statusText: error.response.statusText,
                        detail: error.response.data
                    }
                    Object.assign(this.errorMsg,{show:true, text: errTxt, type:"error"}) 
                } else if (error.request) {            
                    this.$router.push(`/Error`)
                } else {            
                    this.$router.push(`/Error`)
                }    
            })
        },
        deleteDevice () {
            this.errorMsg.show=false
            if (confirm(`Are you sure to delete ${this.device.macaddress}`)) {
                axios
                .delete(
                    this.$store.state.api_url+`/devices/`+this.macaddress,
                    {headers: { Authorization: `Bearer ${this.access_token}`}}
                )
                .then((response)=>{
                    Object.assign(this.errorMsg,{show:true, text: response.data.message, type:"success"})
                    this.macaddress=null
                    this.device={}
                })
                .catch((error)=>{
                    if (error.response) {        
                        //this.$router.push(`/Error?errorCode=${error.response.status}&errorText=${error.response.statusText}`)
                        const errTxt = {
                            status: error.response.status,
                            statusText: error.response.statusText,
                            detail: error.response.data
                        }
                        Object.assign(this.errorMsg,{show:true, text: errTxt, type:"error"}) 
                    } else if (error.request) {            
                        this.$router.push(`/Error`)
                    } else {            
                        this.$router.push(`/Error`)
                    } 
                })
                
                
            }
        }
    }    
});
</script>